import React, { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const ROLE_LABEL = {
  PLATFORM_OWNER: "Platform Owner", PLATFORM_ADMIN: "Platform Admin", SUPPORT: "Support",
  FINANCE: "Finance", DEVELOPER: "Developer", VIEWER: "Viewer",
};

export function ProfileTab({ user, onUpdated }) {
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { setName(user?.name || ""); setEmail(user?.email || ""); }, [user?.name, user?.email]);

  const dirty = name.trim() !== (user?.name || "") || email.trim().toLowerCase() !== (user?.email || "");

  const save = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim()) { setError("Nama tidak boleh kosong"); return; }
    setBusy(true);
    try {
      const r = await api.patch("/platform/me", { name: name.trim(), email: email.trim().toLowerCase() });
      onUpdated?.(r.data.user);
      toast.success(r.data.email_changed ? "Profil & email diperbarui" : "Profil diperbarui");
    } catch (err) {
      const msg = formatApiError(err) || "Gagal menyimpan profil";
      setError(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={save} className="space-y-5" data-testid="account-profile-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label htmlFor="account-name" className="text-white/70">Nama</Label>
          <Input id="account-name" value={name} maxLength={100} onChange={(e) => setName(e.target.value)}
            className="bg-white/5 border-white/10 text-white" data-testid="account-name-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="account-email" className="text-white/70">Email</Label>
          <Input id="account-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="bg-white/5 border-white/10 text-white" data-testid="account-email-input" />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 text-sm">
        <div className="rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2.5">
          <div className="text-[11px] uppercase tracking-widest text-white/40">Role</div>
          <div className="font-bold text-white" data-testid="account-role">{ROLE_LABEL[user?.platform_role] || user?.platform_role || "-"}</div>
        </div>
        <div className="rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2.5">
          <div className="text-[11px] uppercase tracking-widest text-white/40">Status akun</div>
          <div className="font-bold text-white" data-testid="account-status">{user?.account_status || "-"}</div>
        </div>
      </div>
      <p className="text-xs text-white/40">Role dan status akun dikelola oleh Platform Owner melalui menu Team.</p>
      {error ? <div className="text-sm text-red-300" role="alert" data-testid="account-profile-error">{error}</div> : null}
      <Button type="submit" disabled={busy || !dirty} className="dynicty-gradient-bg text-white font-bold" data-testid="account-profile-save">
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Save size={16} className="mr-2" />} Simpan Perubahan
      </Button>
    </form>
  );
}
